import { Routes, Route } from 'react-router-dom';
import { PortalShell } from '@/layouts/PortalShell';
import { RequireAuth } from '@/components/auth/RequireAuth';
import DirectoryPage from '@/pages/Directory';
import MyRunsPage from '@/pages/MyRuns';
import NotFound from '@/pages/NotFound';
import OverviewPage from '@/pages/procedure/Overview';
import StartPage from '@/pages/procedure/Start';
import RunnerPage from '@/pages/procedure/Runner';
import DonePage from '@/pages/procedure/Done';
import LoginPage from '@/pages/auth/login';
import PlanningCentreCallbackPage from '@/pages/auth/planning-centre-callback';

/**
 * Routes. A QR code on the equipment opens /p/{code}. Public procedures need no sign-in (name +
 * ministry once per phone); private ones answer sign_in_required and the overview shows the sign-in
 * screen, returning to /p/{code} afterwards.
 */
export default function App() {
  return (
    <Routes>
      <Route element={<PortalShell />}>
        <Route path="/" element={<DirectoryPage />} />
        <Route path="/p/:code" element={<OverviewPage />} />
        <Route path="/p/:code/start" element={<StartPage />} />
        <Route path="/p/:code/run/:runId" element={<RunnerPage />} />
        <Route path="/p/:code/done/:runId" element={<DonePage />} />
        <Route path="/me/runs" element={<RequireAuth><MyRunsPage /></RequireAuth>} />
        <Route path="/auth/login" element={<LoginPage />} />
        <Route path="/auth/oauth/planning-centre/callback" element={<PlanningCentreCallbackPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
